import type { IPrimer, IUser } from 'Model/index.js'
import type { Observable } from 'rxjs'
import { Environment } from '../../environment.js'
import { get, post } from '../index.js'
import type { RegistryPrimer } from '../../Generated/RegistryPrimer.ts'
import type { OrgPrimerHistory } from '../../Generated/OrgPrimerHistory.ts'

export const getPrimer = (data: { forwardSequence: string; reverseSequence: string }, user?: IUser): Observable<IPrimer> => {
  return get(`${Environment.API_URL}/v1/primer`, data, user)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createPrimerAdd = (data: IPrimer, user?: IUser): Observable<any> => {
  return post(`${Environment.API_URL}/v1/primer/`, data, user)
}

/** Live canonical primer registrations. */
export const getPrimerRegistry = (): Observable<RegistryPrimer[]> => get(`${Environment.API_URL}/api/primers/registry`)

/** The primer pairs entered on recent orders the caller's organisation is lab or customer of. */
export const getOrgPrimerHistory = (): Observable<OrgPrimerHistory> => get(`${Environment.API_URL}/api/primers/history`)
